export default __webpack_public_path__ + "static/media/vii_logo_512.be52f4aa.png";